import React from "react";
import {
  WidgetDetails,
  Title,
  Image,
} from "../../assets/styled/RakthermWorldwide";

const GlobalNetworks = () => {
  return (
    <>
      <Title>RAKTHERM GLOBAL NETWORKS</Title>

      
      <WidgetDetails>
        RAKtherm has formidable market presence within global operational hubs
        for extensive distribution in several countries across the regions of
        GCC, North & South Africa, South & East Asia, and Europe.
      </WidgetDetails>
      <Image src="https://www.raktherm.com/assets/images/map1.jpg" />
    </>
  );
};

export default GlobalNetworks;
